"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementModalContainer = void 0;
var react_1 = __importDefault(require("react"));
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var AngularSyncStore_1 = require("@CommonFrontend/Utils/AngularSyncStore");
var AgreementModal_1 = require("@CommonFrontend/AgreementView/AgreementModal");
var BlockTitle_1 = require("./Components/BlockTitle");
var AgreementBlockEditor_1 = require("./Components/AgreementBlockEditor");
var partiallyApplyComponent_1 = __importDefault(require("@CommonFrontend/QuoteV2/Components/partiallyApplyComponent"));
var AcceptForm_1 = require("./Components/AcceptForm");
var AgreementBlockSettings_1 = require("./Components/AgreementBlockSettings");
var AgreementContextProvider_1 = require("./Components/AgreementContextProvider");
var AgreementErrorBoundary_1 = require("./Components/AgreementErrorBoundary");
var AgreementNavigationDrawer_1 = __importDefault(require("@CommonFrontend/AgreementView/AgreementNavigationDrawer"));
var BlockActionsMenu_1 = require("./Components/BlockActionsMenu");
var AgreementButton_1 = require("../Accept/Controls/Agreement/AgreementButton");
var AcceptBlockStore_1 = __importDefault(require("../Accept/AcceptBlockStore"));
var TokensPopover_1 = require("Project/Actions/Tokens/TokensPopover");
var DownloadPdfButton_1 = __importDefault(require("./Components/DownloadPdfButton"));
var AgreementModalContainer = function (_a) {
    var onDismiss = _a.onDismiss, di = _a.di, usingFeature = _a.usingFeature, modalService = _a.modalService, $scope = _a.$scope, $timeout = _a.$timeout, acceptBlockSettings = _a.acceptBlockSettings, project = _a.project, isStripeIntegrationEnabled = _a.isStripeIntegrationEnabled, stripePublicKey = _a.stripePublicKey, telemetry = _a.telemetry, acceptBlock = _a.acceptBlock, notifyUser = _a.notifyUser, deleteBlock = _a.deleteBlock, blockCreator = _a.blockCreator, savedBlockService = _a.savedBlockService, navigator = _a.navigator, pdfUrl = _a.pdfUrl, acceptPreviewEventEmitter = _a.acceptPreviewEventEmitter, rootDataStore = _a.rootDataStore;
    var block = di.get("block");
    var $state = di.get("$state");
    var overlayStack = di.get("overlayStack");
    var showDeleteModal = di.get("showDeleteModal");
    return (react_1.default.createElement(DIProvider_1.default, { container: function () {
            var container = new inversify_1.Container({ skipBaseClassChecks: true });
            container.bind("angularData").toConstantValue($scope.ui);
            container.bind(AgreementModal_1.AgreementStore).toSelf();
            container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue(!!$scope ? { $scope: $scope, $timeout: $timeout } : { disableSync: true });
            container.bind(AgreementModal_1.AgreementModalComponents.$).toConstantValue({
                BlockTitle: BlockTitle_1.BlockTitle,
                AgreementNavigationDrawer: AgreementNavigationDrawer_1.default,
                DownloadPdfButton: DownloadPdfButton_1.default,
                BlockContent: (0, partiallyApplyComponent_1.default)(AgreementBlockEditor_1.AgreementBlockEditor, { di: di }),
                AcceptForm: (0, partiallyApplyComponent_1.default)(AcceptForm_1.AcceptForm, {
                    onCloseModal: onDismiss,
                    isStripeIntegrationEnabled: isStripeIntegrationEnabled,
                    stripePublicKey: stripePublicKey,
                    acceptBlockSettings: acceptBlockSettings,
                }),
                BlockSettings: (0, partiallyApplyComponent_1.default)(AgreementBlockSettings_1.AgreementBlockSettings, {
                    acceptBlock: acceptBlock,
                    notifyUser: notifyUser,
                    deleteBlock: deleteBlock,
                    blockCreator: blockCreator,
                }),
                TokensPopover: (0, partiallyApplyComponent_1.default)(TokensPopover_1.TokensPopover, { rootDataStore: rootDataStore }),
                AgreementContextProvider: AgreementContextProvider_1.AgreementContextProviderComponent,
                ErrorBoundary: AgreementErrorBoundary_1.AgreementErrorBoundary,
                BlockActionsMenu: BlockActionsMenu_1.BlockActionsMenu,
            });
            container.bind("modalService").toConstantValue(modalService);
            container.bind("savedBlockService").toConstantValue(savedBlockService);
            container.bind("project").toConstantValue(project);
            container.bind("projectSecret").toConstantValue(project.links[0].secret);
            container.bind("usingFeature").toConstantValue(usingFeature);
            container.bind("telemetry").toConstantValue(telemetry);
            container.bind("navigator").toConstantValue(navigator);
            container.bind("pdfUrl").toConstantValue(pdfUrl);
            container.bind(AcceptBlockStore_1.default).toSelf();
            container.bind("acceptPreviewEventEmitter").toConstantValue(acceptPreviewEventEmitter);
            return container;
        } },
        react_1.default.createElement(AgreementButton_1.AgreementEditorContextProvider, { block: block, navigator: $state.go, savedBlockService: savedBlockService, overlayStack: overlayStack, telemetry: telemetry, "$timeout": $timeout, showDeleteModal: showDeleteModal, projectId: block.projectId },
            react_1.default.createElement(AgreementModal_1.AgreementModal, { onDismiss: onDismiss }))));
};
exports.AgreementModalContainer = AgreementModalContainer;
